import React from "react";
import styles from './resolutionMobile.module.css';
import { Button, TextField } from "@mui/material";
import { Camera, Plus, UploadCloud, X } from "react-feather";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
import { toast } from 'react-smart-toaster';

const ResolutionMobile = ({ isPanelOpen, onToggle, requestData, setLoading, setRequestData }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { user, isAuthenticated } = useAuth0();
  const [descVal, setDescVal] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState(0);

  useEffect(() => {
    if (requestData) {
      setDescVal(requestData?.resolution);
    }
  }, [requestData]);

  useEffect(() => {
    const handler = setTimeout(async () => {

      if (descVal !== '') {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.put(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests-new/" + requestData?.id, { resolution: descVal }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((response) => {

          setRequestData(prev => {
            return { ...prev, resolution: response.data.data?.resolution };
          });


        }).catch(() => { });
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [descVal, getAccessTokenSilently]);

  const deleteConfirm = async () => {
    setOpenDeleteModal(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/files/' + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setRequestData(prev => {
        if (deleteType === 1) {
          let images = prev?.resolve_images?.filter(i => i?.id !== deleteId);
          return { ...prev, resolve_images: images };
        } else {
          let images = prev?.images?.filter(i => i?.id !== deleteId);
          return { ...prev, images: images };
        }
      });

      let logData = {
        'title': 'Maintenance resolution image deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);
    }).catch(error => { });
  }

  const fileHandler = async (e) => {
    let extErr = false;
    let sizeErr = false;
    let files = e.target.files;
    let allowedExtensionArr = ".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf".split(',');

    if (files.length > 0) {
      if (allowedExtensionArr.length > 0) {
        let fileName = files[0].name;
        let fileSize = files[0].size;
        let fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        fileNameExt = '.' + fileNameExt;

        if (allowedExtensionArr.indexOf(fileNameExt) === -1) {
          extErr = true;
        }

        if (fileSize >= 5242880) {
          sizeErr = true;
        }
      }
    }

    if (extErr) {
      toast.error("File type is not allowed.");
      return false;
    }

    if (sizeErr) {
      toast.error("File size should not be greater than 5 MB.");
      return false;
    }

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);

    let formData = new FormData();
    formData.append("image", files[0]);

    axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/resolve-files/upload', formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(response => {
      setLoading(false);


      setRequestData(prev => {
        let images = response.data.data.concat(prev?.resolve_images);
        return { ...prev, resolve_images: images };
      });

      let logData = {
        'title': 'Maintenance request resolution image uploaded',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
        ]
      }
      AddLogCallAPI(logData, token);

    }).catch(error => {
      setLoading(false);
    });
  }

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("one")}>
          <p className={`${styles.Title}`}>Resolution</p>
          <img src="/static/img/downTriangle.svg" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          <div className={`${styles.AccouFormGroup}`}>
            <form>
              <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                  <div className={`${styles.FormSec}`}>
                    <div className={`${styles.FormGroupFull} FormGroup`}>
                      <label className={`${styles.FilterLabel}`}>Describe the Resolution</label>
                      <TextField id="outlined-multiline-static" label="Add Description*" multiline rows={6} value={descVal}
                        onChange={(e) => {
                          setDescVal(e.target.value);
                        }} />
                    </div>
                  </div>
                  <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                    <label className={`${styles.FilterLabel}`}>Share a Documents/Photos</label>
                    <div className={`${styles.FileIMGDiv}`}>
                      <div className={`${styles.FileUpDuBUDiv}`}>
                        {/* <label for="file-upload" className={`${styles.UploadLabel}`}>
                          <UploadCloud />
                          <p>Upload Documents/Photos</p>
                        </label> */}
                        {requestData?.resolve_images?.length === 0 && (<label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Documents/Photos</label>)}
                        <input id="file-upload" type="file" multiple onChange={fileHandler} accept={".jpg,.png,.jpeg,.svg,.doc,.docx,.xls,.xlsx,.pdf"} />
                        {requestData?.resolve_images?.length === 0 && (<p className={`${styles.UploadText}`}>File size upto 10 MB. JPG, PNG, PDF, DOC, XLS file only</p>)}
                      </div>

                      <div className={`${styles.UpIMGSec}`}>
                        {requestData?.resolve_images?.map((item, index) => {
                          return (<div className={`${styles.ImgFile}`}>
                            {((item?.file_path.split('.').pop() === 'doc' || item?.file_path.split('.').pop() === 'docx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/docIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'xls' || item?.file_path.split('.').pop() === 'xlsx') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/excelIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : ((item?.file_path.split('.').pop() === 'pdf') ? <a href={item.file_public_url} target="_blank" rel="noopener noreferrer" className={styles.FileLink} >
                              <img src="/static/img/pdfIcon.png" />
                              <p className={`${styles.FilePathName}`}>{item?.file_name}</p>
                            </a> : <img src={item?.file_public_url} className={styles.UpIMG} alt="" />)))}
                            <Button onClick={(e) => { setOpenDeleteModal(true); setDeleteId(item?.id); setDeleteType(1); }}> <X /> </Button>
                          </div>)
                        })}
                        {requestData?.resolve_images?.length > 0 && (<label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>)}
                        {requestData?.resolve_images?.length === 0 && (
                          <div className={`${styles.NoImgDiv}`}>
                            <img src="/static/img/no-photo.png" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResolutionMobile;
